(function () {
  const STORAGE_KEY = "wishlist";

  function readWishlistItems() {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      const parsed = stored ? JSON.parse(stored) : null;
      return Array.isArray(parsed && parsed.items) ? parsed.items : [];
    } catch (error) {
      return [];
    }
  }

  function getWishlistProductIds() {
    return new Set(
      readWishlistItems()
        .map((item) => String(item.product_id || ""))
        .filter(Boolean),
    );
  }

  function getWishlistVariantIds() {
    return new Set(
      readWishlistItems()
        .map((item) => String(item.variant_id || ""))
        .filter(Boolean),
    );
  }

  async function renderWishlistPage(root) {
    const grid = root.querySelector("[data-wishlist-grid]");
    const empty = root.querySelector("[data-wishlist-empty]");

    // Always remove the initial static loader generated by Shopify HTML
    const initialLoader = root.querySelector('[data-wishlist-loading]');
    if (initialLoader) initialLoader.remove();
    
    const items = readWishlistItems();
    const validItems = items.filter(i => i.product_id || i.variant_id);

    // If completely empty
    if (validItems.length === 0) {
      if (empty) empty.hidden = false;
      if (grid) {
         grid.hidden = true;
         grid.style.display = 'none'; // Fix for CSS overriding [hidden]
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (grid) {
      grid.hidden = false;
      grid.style.display = '';
    }

    const orderedIds = items.map(i => String(i.product_id || "")).filter(Boolean).reverse();
    
    // Check what is currently in the DOM
    let existingCards = Array.from(root.querySelectorAll("[data-wishlist-card]"));
    const existingIds = new Set(existingCards.map(card => card.getAttribute("data-product-id")));
    
    const missingIds = orderedIds.filter(id => !existingIds.has(id));

    // If we have missing products, we need to fetch them
    if (missingIds.length > 0) {
      // Show loading ONLY if it's the initial load (no cards yet)
      if (existingCards.length === 0 && grid) {
        grid.style.display = 'none'; // hide grid during loading to avoid mobile layout issues
        let loader = grid.parentElement.querySelector('.wishlist-global-loader');
        if (!loader) {
           loader = document.createElement('div');
           loader.className = 'wishlist-global-loader';
           loader.innerHTML = '<p>Loading your wishlist...</p>';
           loader.style.cssText = 'padding: 100px 0; text-align: center; width: 100%; font-size: 1.6rem;';
           grid.parentElement.insertBefore(loader, grid);
        }
      }

      const chunkSize = 20;
      const fetchPromises = [];
      const fetchedCardsMap = new Map();
      
      for (let i = 0; i < missingIds.length; i += chunkSize) {
        const chunk = missingIds.slice(i, i + chunkSize);
        const query = chunk.map(id => `id:${id}`).join(' OR ');
        
        const promise = fetch(`/search?type=product&q=${encodeURIComponent(query)}&section_id=main-search`)
          .then(res => res.text())
          .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const fetchedCards = doc.querySelectorAll('#product-grid .grid__item');
            
            fetchedCards.forEach(cardLi => {
              const btn = cardLi.querySelector('.wishlist-btn');
              if (btn) {
                const prodId = btn.getAttribute('data-product-id');
                const variantId = btn.getAttribute('data-variant-id');
                
                if (prodId) {
                  const newDiv = document.createElement('div');
                  newDiv.className = 'wishlist-page__item';
                  newDiv.setAttribute('data-wishlist-card', '');
                  newDiv.setAttribute('data-product-id', prodId);
                  newDiv.setAttribute('data-variant-id', variantId || '');
                  newDiv.innerHTML = cardLi.innerHTML;
                  
                  const newBtn = newDiv.querySelector('.wishlist-btn');
                  if (newBtn) newBtn.classList.add('active');
                  
                  fetchedCardsMap.set(String(prodId), newDiv);
                }
              }
            });
          })
          .catch(e => console.error('Error fetching wishlist products', e));
          
        fetchPromises.push(promise);
      }
      
      await Promise.all(fetchPromises);
      
      // Add fetched cards to existingCards list
      fetchedCardsMap.forEach(card => existingCards.push(card));
      
      // Remove loading spinner
      if (grid) {
         grid.style.display = ''; // restore grid display
         const loader = grid.parentElement.querySelector('.wishlist-global-loader');
         if (loader) loader.remove();
      }
    }

    // Now update visibility and order
    let visibleCount = 0;
    const orderedIdsSet = new Set(orderedIds);

    existingCards.forEach(card => {
       const id = card.getAttribute("data-product-id");
       if (orderedIdsSet.has(id)) {
          card.hidden = false;
          card.style.display = '';
          visibleCount++;
          
          const btn = card.querySelector('.wishlist-btn');
          if (btn) btn.classList.add('active');
       } else {
          card.hidden = true;
          card.style.display = 'none';
          
          const btn = card.querySelector('.wishlist-btn');
          if (btn) btn.classList.remove('active');
       }
    });

    // Sort the cards in the DOM based on orderedIds
    existingCards.sort((a, b) => {
      const indexA = orderedIds.indexOf(a.getAttribute("data-product-id"));
      const indexB = orderedIds.indexOf(b.getAttribute("data-product-id"));
      const valA = indexA > -1 ? indexA : 9999;
      const valB = indexB > -1 ? indexB : 9999;
      return valA - valB;
    });

    // Re-append to grid in the correct order
    existingCards.forEach(card => {
      if (grid) {
         grid.appendChild(card);
      }
    });

    if (grid) {
       if (visibleCount === 0) {
         grid.hidden = true;
         grid.style.display = 'none';
       } else {
         grid.hidden = false;
         grid.style.display = '';
       }
    }
    
    if (empty) empty.hidden = visibleCount !== 0;
  }

  function initWishlistPage(root) {
    renderWishlistPage(root);

    window.addEventListener('wishlist:updated', () => {
      renderWishlistPage(root);
    });
  }

  function runInit() {
    document.querySelectorAll("[data-wishlist-page]").forEach(initWishlistPage);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }
})();
